export const RouterConstants = {
    default: '',
    auth: 'auth',
    client: 'client',
    firsttime:'firsttlogin/changepassword',
    login: 'login',
    resetPassword: 'reset-password',
    resetpasswordsuccess: 'resetpasswordsuccess',
    passwordsuccess: 'passwordsuccess',
    resetpasswordchange: 'resetpasswordchange/:id',
    layoutContainer: 'help-desk',
    dashboard: 'dashboard',
    tickets: {
        baseUrl: 'tickets',
    },
    solutions: {
        baseUrl: 'solutions',
    },
    reports: {
        baseUrl: 'reports',
        ticket: 'ticket',
    },
    setup: {
        baseUrl: 'setup',
        company: 'company',
        orgInfo: 'org-info',
        contactInfo: 'contacts',
        agentSetup: 'agent',
        grouping: 'grouping',
        automation: 'automation',
        escalation: 'escalation',
        configuration: 'configuration'
    },
    userProfile: {
        baseUrl: 'user',
        myProfile: 'my-profile',
        editProfile: 'edit-profile',
        changePassword: 'change-password'
    },
}